import { Component } from '@theme/component';

/**
 * Fades the Memory Anchor fragment in once it enters the viewport.
 * @extends {Component}
 */
class MemoryAnchorComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.classList.add('memory-anchor--visible');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.classList.add('memory-anchor--visible');
            this.observer?.disconnect();
          }
        }
      },
      { threshold: 0.3 }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.observer?.disconnect();
  }
}

if (!customElements.get('memory-anchor-component')) {
  customElements.define('memory-anchor-component', MemoryAnchorComponent);
}
